export interface IExhutProfile {
  firstName: string;
  lastName: string;
  email: string;
  username: string;
  phone: string;
  countryCode: string;
  entitlement: number;
  houseNumber: string;
  street1: string;
  street2?: string;
  city: string;
  state: string;
  zipCode: string;
  dob: string;
}

export interface IUser {
  username: string;
  sign: string;
  firstname: string;
  lastname: string;
  email: string;
  useremail: string;
  admin: boolean;
  country_code: string;
  entitlement: number;
  phone: string;
}

// this is primarily the user schema in exhut-auth-service
export interface IExhutAuthUser {
  firstName: string;
  lastName: string;
  email: string;
  countryCode: string;
  username: string;
  phone: string;
}

export type IGroupUser = Pick<
  IExhutAuthUser,
  "email" | "firstName" | "lastName" | "email" | "countryCode" | "username"
>;

export interface IGroup {
  id: string;
  name: string;
  groupusers: string[];
  created_at: string;
  created_by: string;
}

export interface IGroup2 {
  id: string;
  name: string;
  groupusers: string[];
  createdAt: string;
  createdBy: string;
}

export interface ITrip {
  destination?: string;
  fromDate: string;
  groupId: string;
  id: string;
  mode?: any;
  name: string;
  total: number;
  toDate: string;
  username: string;
}

export interface ISavingsGoal {
  id: string;
  name: string;
  username: string;
  targetAmount: number;
  targetDate: string;
  groupId: string;
  users?: string[];
  createdAt: string;
  // Computed on the backend
  savedAmount: number;
  completed: boolean;
}

export interface ISavingsGoalItem {
  id: string;
  goalId: string;
  amount: number;
  itemDate: string;
  note?: string;
  username: string;
  createdAt: string;
}

export interface IAccount {
  id: string;
  name: string;
  username: string;
  plaidAccount?: IPlaidAccount;
}

export interface IPlaidAccount {
  bankId: string;
}

export interface ILedger {
  createdDate: string;
  currency: string;
  description: string;
  groupId: string;
  id: string;
  name: string;
  shared: boolean;
  total: number;
  username: string;
}

export interface ICreditCard {
  id: string;
  name: string;
  username: string;
}

export interface ITotal {
  total: number;
}

export type IImportExpensePayload = Pick<
  IExpense2,
  "amount" | "expenseDate" | "category" | "comments"
>;

export interface IExpense2 {
  amount: number;
  cardname: string;
  category: string;
  comments: string;
  created_at: string;
  creditcard: string;
  expense_source: string;
  expenseDate: string;
  groupId: string;
  id: string;
  ledger_id?: any;
  subcategory: string;
  trash?: boolean;
  tripid: string;
  type?: string;
  username: string;
  location?: string;
  transaction_type?: string;
  merchantLogo: string;
  merchantName: string;
  paymentChannel: string;
  plaidCategories: string;
}

export interface ISavings {
  amount: number;
  createdAt: string;
  description: string;
  groupId: string;
  id: string;
  savingsDate: string;
  shared?: boolean;
  username: string;
  users: string[];
}

export type ICardDetails = {
  cardToken?: string;
  expiry?: string;
};

export interface IPlan {
  id: number;
  name: string;
  price: number;
  period: string;
  bgColor: string;
  badge?: string;
  badgeColor?: string;
  description: string;
  highlight: boolean;
  features: string[];
  gradient: string;
  buttonColor: string;
  borderColor: string;
}

export interface ISubscription {
  createdAt: string;
  entitlement: number;
  id: string;
  status: string;
  username: string;
  monthlyCycleDate: string;
  amount: number;
  total: number;
  tax: number;
}

export interface ICurrencyRates {
  USD: number;
  GBP: number;
  CAD: number;
  AUD: number;
  SGD: number;
  INR: number;
  EUR: number;
  HKD: number;
  AED: number;
}

export interface ILimit {
  plaidAccounts: number;
  groups: number;
  tripsPerMonth: number;
  ledgers: number;
}

export interface IIncome {
  id: string;
  name: string;
  users: string[];
  createdDate: string;
  amount: number;
}

export interface INotification {
  id: string;
  content: string;
  type: TRANSACTION_TYPE;
  timestamp: string;
  username: string;
}

export enum TRANSACTION_TYPE {
  SCAN = "SCAN_RECEIPT",
  EXPENSE_ADD = "ADD_EXPENSE",
  SAVINGS_ADD = "ADD_SAVINGS",
  SMS_EXPENSE = "SMS_EXPENSE",
  PLAID_GET_EXPENSE_SUCCESS = "PLAID_GET_EXPENSE_SUCCESS",
  PLAID_GET_EXPENSE_ERROR = "PLAID_GET_EXPENSE_ERROR",
  PLAID_GET_BALANCE_SUCCESS = "PLAID_GET_BALANCE_SUCCESS",
  PLAID_GET_BALANCE_ERROR = "PLAID_GET_BALANCE_ERROR",
  PLAID_CONNECT_SUCCESS = "PLAID_CONNECT_SUCCESS",
  PLAID_CONNECT_ERROR = "PLAID_CONNECT_ERROR",
  MERGE_ACCOUNT_SUCCESS = "MERGE_ACCOUNT_SUCCESS",
}
